export default __webpack_public_path__ + "static/media/flask.932320f6.png";